/* !!!!!!!!!!!!!!!!!!!!!! */
/* !!! GENERATED FILE !!! */
/* !!!!!!!!!!!!!!!!!!!!!! */

import {
  ModuleDoneType,
  ModuleType,
  PlaniraPlanImage,
  type PlaniraTemplate,
} from "../../types";
import { PlanType } from "../../types";
import { PlanTemplateType } from "../template_types";

export const FlowDinnerPartyTemplate: PlaniraTemplate = {
  type: PlanTemplateType.FlowDinnerParty,

  planType: PlanType.Quickstart,
  suggestedTitles: [
    "An Evening of Elegance!",
    "Let’s Dine in Style!",
    "A Feast to Remember!",
  ],
  title: "Dinner Party",
  description: "Organize an elegant dinner party at home.",
  longDescription:
    "Plan a sophisticated dinner party. Choose the best date, decide on cuisine, and select drinks and dessert to impress your guests!",
  emoji: "🍽",
  titleHelp: "Change title or choose another:",
  imageType: PlaniraPlanImage.Party,

  sections: [
    {
      section: {
        isExpandable: false,
        isDraggable: false,
      },
      modules: [
        {
          type: ModuleType.PlanInfo,
          doneType: ModuleDoneType.None,
          title: "Dinner Party",
          emoji: "🍽",
        },
      ],
    },
    {
      section: {
        title: "Ongoing",
      },
      modules: [
        {
          type: ModuleType.Calendar,
          doneType: ModuleDoneType.Voting,
          title: "When should we have the dinner party?",
          emoji: "📅",
          completeAction: {
            question: "Decide on cuisine?",
            description:
              "What type of cuisine do you want for the dinner party?",
            addModules: [
              {
                type: ModuleType.Poll,
                doneType: ModuleDoneType.Voting,
                title: "What cuisine should we choose?",
                emoji: "🍜",
                completeAction: {
                  question: "Select drinks and dessert?",
                  description: "What drinks and dessert should we serve?",
                  addModules: [
                    {
                      type: ModuleType.Poll,
                      doneType: ModuleDoneType.Voting,
                      title: "What drinks should we serve?",
                      emoji: "🍷",
                    },
                    {
                      type: ModuleType.Poll,
                      doneType: ModuleDoneType.Voting,
                      title: "What dessert should we have?",
                      emoji: "🍰",
                    },
                  ],
                },
              },
            ],
          },
        },
      ],
    },
  ],

  onTemplateComplete: {
    outroTitle: "Bon Appétit!",
    outroDescription:
      "Your dinner party is all set! Get ready to impress your guests!",
  },
};
